import { projectFirestore } from '../../firebase/config'
import { useParams, Link } from 'react-router-dom'
import { useEffect, useState } from 'react'
import { useTheme } from '../../hooks/useTheme'

// styles
import './Post.css'

export default function Post() {
    const { id } = useParams()
    const { mode } = useTheme()

    const [journal, setJournal] = useState(null)
    const [isPending, setIsPending] = useState(false)
    const [error, setError] = useState(false)


    useEffect(()=> {
        setIsPending(true)

        projectFirestore.collection('journals').doc(id).get().then((doc) => {
            if (doc.exists) {
                setIsPending(false)
                setJournal(doc.data())
            } else {
                setIsPending(false)
                setError('Could not find that entry')
            }
        })

    }, [id])


    return (
        <div className={`journal ${mode}`}>
            {error && <p className='error'>{error}</p>}
            {isPending && <p className='loading'>Loading...</p>}
            {journal && (
                <>
                    <div className='breadcrumbs'>
                        <Link to="/">
                            <div className='link-crumb'>/Home </div>
                        </Link>
                        <Link to="/journal">
                            <div className='link-crumb'> /Journals </div>
                        </Link>
                        <div className='link-crumb'> /{journal.title}</div>
                    </div>
                    <h2 className='page-title'>{journal.title}</h2>
                    <img src={journal.icon} alt={`${journal.title} icon`} className='icon'/>
                    <p>{journal.date}</p>
                    <h3 className='summary'>Journal Summary:</h3>
                    <ul>
                        {journal.bullets.map(bullet => <li key={bullet}>{bullet}</li>)}
                    </ul>
                    {journal.game_title &&
                    <>
                        <h3 className='game-link'>Play Game: {journal.game_title}</h3>
                        <a href={journal.game_link} target="_blank" rel="noreferrer">Play Game Here</a>
                    </>
                    }
                    {journal.lesson &&
                    <div>
                        <h3 className='lesson-title'>View created lesson plan:</h3>
                        <a className='lesson-link' href={journal.lesson.link}>{journal.lesson.title}</a>
                    </div>}
                    {journal.readings_summary && 
                    <div className='readings'>
                        <h3 className='summary'>Class Readings Summary:</h3>
                        {
                            journal.readings_summary.map(summary =>
                                <div key={summary.id}>
                                    <h5>{summary.title}</h5>
                                    <p>{summary.summary}</p>
                                </div>
                            )
                        }
                    </div>}
                    {journal.images && journal.images.map(image => 
                        <div key={image.id}>
                            <img src={image.image} alt={image.description}/>
                            <p>{image.description}</p>
                        </div>
                        )}
                    {journal.youtube_id &&
                    <div>
                        <h4>{journal.youtube_title}</h4>
                        <iframe className='video'
                                title='Youtube player'
                                sandbox='allow-same-origin allow-forms allow-popups allow-scripts allow-presentation'
                                src={`https://youtube.com/embed/${journal.youtube_id}?autoplay=0`}>
                        </iframe>
                    </div>}
                    {journal.reflections && 
                    <div className='readings'>
                        <h3 className='summary'>Final Reflections:</h3>
                        <p>{journal.reflections}</p>
                    </div>}
                </>
            )}
             <Link to="/journal">
                <div className='link'>&#8592; Back to all Journals</div>
            </Link>
        </div>
    )
}